module.exports = __webpack_public_path__ + "static/media/myRemindersGray.376bb145.png";